import { minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

const LoadMoreButton = styled.button`
  position: relative;
  border: none;
  background: none;
  padding: 1rem 3rem;
  color: ${({ theme }) => theme.colors.white};
  transition: all 0.2s ease;
  z-index: 2;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: -1px;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.grey};
    z-index: -1;
    clip-path: polygon(0% 0%, 100% 0%, calc(100% - 31px) 100%, 31px 100%);
  }
  &:hover {
    opacity: 0.8;
  }
  @media ${minWidthQueries.md} {
    padding: 1rem 5rem;
  }
`
const LoadMoreBg = styled.div`
  position: absolute;
  left: 0;
  top: -1px;
  width: 100%;
  height: 100%;
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    right: -42px;
    top: 0;
    width: 70px;
    height: 100%;
    z-index: 1;
    background: ${({ theme }) => theme.colors.teal};
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 39px 0%);
    transform: scaleX(-1);
  }
  &:before {
    content: '';
    position: absolute;
    background: ${({ theme }) => theme.colors.teal};
    left: -42px;
    width: 70px;
    height: 100%;
    z-index: 1;
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 39px 0%);
  }
`

const TealGreyButton = ({ onClick, label }) => {
  return (
    <LoadMoreButton type="button" onClick={() => onClick()}>
      <LoadMoreBg />
      {label}
    </LoadMoreButton>
  )
}

export default TealGreyButton
